/** Exponential backoff 1 s → 60 s with full jitter (§7.5). */
export class Backoff {
  private attempt = 0;

  constructor(
    private readonly baseMs = 1_000,
    private readonly maxMs = 60_000,
  ) {}

  reset(): void {
    this.attempt = 0;
  }

  nextDelay(): number {
    const cap = Math.min(this.maxMs, this.baseMs * 2 ** this.attempt);
    this.attempt = Math.min(this.attempt + 1, 16);
    return Math.round(cap / 2 + Math.random() * (cap / 2));
  }

  wait(signal?: AbortSignal): Promise<void> {
    const ms = this.nextDelay();
    return new Promise((resolve) => {
      const t = setTimeout(resolve, ms);
      signal?.addEventListener("abort", () => {
        clearTimeout(t);
        resolve();
      });
    });
  }
}
